import {fabric} from 'fabric'
export function makeTextBoxWithBorder(canvas) {
    canvas.on('mouse:down', function(options) {
        if((options.target == null) || (options.target.type === 'image') ){
            addText(options.e); 
        }
        
    });

    function addText(e) {
        var originalRender = fabric.Textbox.prototype._render;
        console.log(e);
        fabric.Textbox.prototype._render = function(ctx) {
            originalRender.call(this, ctx);
            //Don't draw border if it is active(selected/ editing mode)
            if (this.active) return;
            if(this.showTextBoxBorder){
                var w = this.width,
                    h = this.height,
                    x = -this.width / 2,
                    y = -this.height / 2;
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x + w, y);
                ctx.lineTo(x + w, y + h);
                ctx.lineTo(x, y + h);
                ctx.lineTo(x, y);
                ctx.closePath();
                var stroke = ctx.strokeStyle;
                ctx.strokeStyle = this.textboxBorderColor;
                ctx.stroke();
                ctx.strokeStyle = stroke;
            }
            fabric.Textbox.prototype.cacheProperties = fabric.Textbox.prototype.cacheProperties.concat('active');
        }

        const text = new fabric.Textbox('',{
            left: e.offsetX,
            width:40,
            top: e.offsetY,
            fontSize: 12,
            showTextBoxBorder: true,
            editable:true,
            hasBorders:true,
            textboxBorderColor: '#000',
            fontFamily:"Verdana",
            backgroundColor:"#FAF9F6"
        });
        canvas.add(text);
        canvas.bringToFront(text);
        text.enterEditing();
    }


}
